import { isNumber, orderBy } from 'lodash';

import { IPageDefinition } from '@assess/shared/dynamic-components';

export interface IWeightedNavUrl extends INavUrl {
  weight: number | undefined;
}

export interface INavUrl {
  display: string;
  url: string[];
}

export const buildCustomNavigationLinks = (
  isCustomEnabled: boolean | undefined,
  pageDefinitions: IPageDefinition[] | undefined
) => {
  if (!isCustomEnabled || !pageDefinitions?.length) {
    return [];
  }

  return pageDefinitions.map((pageDefinition) => ({
    display: pageDefinition.name,
    url: ['custom', pageDefinition.slug],
    weight: pageDefinition.sortWeight,
  }));
};
export const buildQualityNavigationLinks = (
  isQualityEnabled: boolean | undefined,
  display: IWeightedNavUrl['display'],
  weight: IWeightedNavUrl['weight']
) => {
  return isQualityEnabled ? [{ display, weight, url: ['quality'] }] : [];
};

export const buildRiskNavigationLinks = (
  isRiskEnabled: boolean | undefined,
  display: IWeightedNavUrl['display'],
  weight: IWeightedNavUrl['weight']
) => {
  return isRiskEnabled ? [{ display, weight, url: ['risk'] }] : [];
};

export const buildNavigationLinks = (
  custom: IWeightedNavUrl[],
  quality: IWeightedNavUrl[],
  risk: IWeightedNavUrl[]
) => {
  const links = [...custom, ...quality, ...risk];

  const { weighted, unweighted } = links.reduce(
    (acc, link) => {
      isNumber(link.weight) ? acc.weighted.push(link) : acc.unweighted.push(link);

      return acc;
    },
    { weighted: [] as any[], unweighted: [] as any[] }
  );

  const submissionLink = { url: ['review'], display: 'Review and Submit' } as INavUrl;

  return [
    ...orderBy(weighted, ['weight', 'display']),
    ...orderBy(unweighted, ['display']),
    submissionLink,
  ] as INavUrl[];
};
